module.exports = __webpack_public_path__ + "static/media/js.8a9ec122.png";